import { webApiBuildUrl } from '@api/utils'

export function goodFeaturesUrl(): string {
    return webApiBuildUrl('api/catalog/goods/features')
}
